import React, { useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAutoDismissMessage } from "../../../shared/hooks/useAutoDismissMessage";

const API_URL = process.env.REACT_APP_API_URL;
const RESET_PASSWORD_ENDPOINT = "/password-reset.php?action=reset";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const [passwordNueva, setPasswordNueva] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useAutoDismissMessage(mensaje, () => setMensaje(""));
  useAutoDismissMessage(error, () => setError(""));

  const validar = () => {
    if (!token) return "El enlace de recuperacion no tiene token.";
    if (!passwordNueva || !confirmarPassword) return "Completa todos los campos.";
    if (passwordNueva.length < 8) return "La nueva contrasena debe tener al menos 8 caracteres.";
    if (passwordNueva !== confirmarPassword) return "Las contrasenas no coinciden.";
    return "";
  };

  const restablecerPassword = async (e) => {
    e.preventDefault();
    setMensaje("");
    setError("");

    const errorValidacion = validar();
    if (errorValidacion) {
      setError(errorValidacion);
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(`${API_URL}${RESET_PASSWORD_ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, passwordNueva })
      });

      const data = await res.json();

      if (res.ok && data?.ok !== false) {
        setMensaje(data?.mensaje || "Contrasena actualizada correctamente.");
        setPasswordNueva("");
        setConfirmarPassword("");
        setTimeout(() => navigate("/login"), 1800);
      } else {
        setError(data?.mensaje || data?.error || "No fue posible restablecer la contrasena.");
      }
    } catch (err) {
      setError("No hay conexion con el servidor. Intenta nuevamente en unos minutos.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-shell" aria-label="Restablecer contrasena">
        <div className="login-hero">
          <div className="login-brand">
            <span className="login-brand-mark">A</span>
            <div>
              <p>Agenda Terapeutica</p>
              <span>Nuevo acceso</span>
            </div>
          </div>

          <div className="login-copy">
            <h1>Crea una nueva contrasena.</h1>
            <p>
              Usa una clave segura y diferente a las anteriores para proteger el acceso a la agenda.
            </p>
          </div>
        </div>

        <div className="login-panel">
          <div className="login-panel-header">
            <p>Seguridad</p>
            <h2>Restablecer contrasena</h2>
            <span>El enlace de recuperacion es temporal.</span>
          </div>

          {mensaje && <div className="login-alert login-alert-success">{mensaje}</div>}
          {error && <div className="login-alert">{error}</div>}

          <form onSubmit={restablecerPassword} className="login-form">
            <div className="login-field">
              <label htmlFor="passwordNueva">Nueva contrasena</label>
              <div className="password-control">
                <input
                  id="passwordNueva"
                  type={showPassword ? "text" : "password"}
                  value={passwordNueva}
                  onChange={(e) => setPasswordNueva(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button type="button" onClick={() => setShowPassword((current) => !current)}>
                  {showPassword ? "Ocultar" : "Ver"}
                </button>
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="confirmarPassword">Confirmar contrasena</label>
              <input
                id="confirmarPassword"
                type={showPassword ? "text" : "password"}
                value={confirmarPassword}
                onChange={(e) => setConfirmarPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>

            <button type="submit" className="login-submit" disabled={isLoading || !token}>
              {isLoading ? "Actualizando..." : "Actualizar contrasena"}
            </button>
          </form>

          <p className="login-note">
            <Link className="login-link" to="/login">Volver al inicio de sesion</Link>
          </p>
        </div>
      </section>
    </main>
  );
}
